import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  VALIDATE_DUPLICATE_AUTH_REQUEST: '',
  VALIDATE_DUPLICATE_AUTH_SUCCESS: '',
  VALIDATE_DUPLICATE_AUTH_FAILURE: '',
};

types = setStoreTypeValues(types, 'authDuplicate');

export default types;
